import { getData } from "./apiUtils";
import * as CONFIG from '../utils/config'

export function getAllGroups() {
    return getData(CONFIG.GET_ALL_GROUPS_URL());
}
